module.exports = __webpack_public_path__ + "images/eq_pause.518a3016.png";